import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

const Pin = styled.button`
  /* Centre the pin on its coordinate */
  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;

  padding: 6px 12px;
  border: 0;
  border-radius: 16px;
  cursor: pointer;

  background-color: white;
  box-shadow:
    0px 0.25px 3px rgba(0, 0, 0, 0.039),
    0px 2.75px 9px rgba(0, 0, 0, 0.19);

  ${typeStyle('-ds-font-body-sm-regular')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  }
`

type MarketCityMarkerProps = {
  /* Consumed by google-map-react to position the marker */
  // eslint-disable-next-line react/no-unused-prop-types
  lat: number
  // eslint-disable-next-line react/no-unused-prop-types
  lng: number
  name: string
  onClick: () => any
}

const MarketCityMarker = ({ name, onClick }: MarketCityMarkerProps) => (
  <Pin type="button" onClick={onClick}>
    Explore {name}
  </Pin>
)

export default MarketCityMarker
